var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "multiselect",
    {
      attrs: {
        options: _vm.items,
        loading: _vm.isLoadingItems,
        "allow-empty": false,
        disabled: !_vm.otherServiceTypeID,
        "custom-label": _vm.otherLabel,
        "internal-search": false,
        placeholder: "Zusatzleistung auswählen",
        "track-by": "id",
        "group-values": "items",
        "group-label": "type",
        "select-label": "",
        "deselect-label": "Löschen",
      },
      on: { "search-change": _vm.otherServiceSearch },
      model: {
        value: _vm.otherServiceSelected,
        callback: function ($$v) {
          _vm.otherServiceSelected = $$v
        },
        expression: "otherServiceSelected",
      },
    },
    [
      _c("template", { slot: "noResult" }, [
        _vm._v("Keine passenden Leistungsträger"),
      ]),
      _vm._v(" "),
      _c("span", { attrs: { slot: "caret" }, slot: "caret" }, [
        _c(
          "a",
          {
            staticClass: "multiselect-crud-link",
            attrs: {
              href: "/others?add",
              title: "Fügen Sie eine neue Leistungsträger hinzu",
              target: "_blank",
            },
          },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("add")])]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }